// Export an array of topics for VA 1st Grade Science
const md3rdScienceQuizContent = [
  {
    "slug": "force",
    "title": "Force",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. A force is…",
        "questionImage": "",
        "answers": [
          { "text": "A push or pull", "correct": true, "image": "" },
          { "text": "A type of sound", "correct": false, "image": "" },
          { "text": "An energy drink", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. A force can change an object’s…",
        "questionImage": "",
        "answers": [
          { "text": "Speed or direction", "correct": true, "image": "" },
          { "text": "Color", "correct": false, "image": "" },
          { "text": "Taste", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which is a force?",
        "questionImage": "",
        "answers": [
          { "text": "A push", "correct": true, "image": "" },
          { "text": "A picture", "correct": false, "image": "" },
          { "text": "A smell", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. A pull can make a wagon…",
        "questionImage": "",
        "answers": [
          { "text": "Move", "correct": true, "image": "" },
          { "text": "Disappear", "correct": false, "image": "" },
          { "text": "Taste sweet", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If you stop pushing, the cart will…",
        "questionImage": "",
        "answers": [
          { "text": "Slow or stop", "correct": true, "image": "" },
          { "text": "Sing", "correct": false, "image": "" },
          { "text": "Glow", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "motion",
    "title": "Motion",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Motion happens when…",
        "questionImage": "",
        "answers": [
          { "text": "Position changes", "correct": true, "image": "" },
          { "text": "It stays still", "correct": false, "image": "" },
          { "text": "It is parked", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If a car moves 10 feet, what happened?",
        "questionImage": "",
        "answers": [
          { "text": "Motion occurred", "correct": true, "image": "" },
          { "text": "Nothing changed", "correct": false, "image": "" },
          { "text": "It vanished", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which shows motion?",
        "questionImage": "",
        "answers": [
          { "text": "A rolling ball", "correct": true, "image": "" },
          { "text": "A closed book", "correct": false, "image": "" },
          { "text": "A parked bus", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. To change direction you must…",
        "questionImage": "",
        "answers": [
          { "text": "Use a force", "correct": true, "image": "" },
          { "text": "Change color", "correct": false, "image": "" },
          { "text": "Change size", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If something is in motion, it is…",
        "questionImage": "",
        "answers": [
          { "text": "Moving", "correct": true, "image": "" },
          { "text": "Sleeping", "correct": false, "image": "" },
          { "text": "Invisible", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "workeasy",
    "title": "Work Easy (Simple Machines)",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Why do we use simple machines?",
        "questionImage": "",
        "answers": [
          { "text": "To make work easier", "correct": true, "image": "" },
          { "text": "To make work harder", "correct": false, "image": "" },
          { "text": "To confuse people", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which simple machine is like a seesaw?",
        "questionImage": "",
        "answers": [
          { "text": "Lever", "correct": true, "image": "" },
          { "text": "Screw", "correct": false, "image": "" },
          { "text": "Wedge", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which simple machine is like a ramp?",
        "questionImage": "",
        "answers": [
          { "text": "Inclined plane", "correct": true, "image": "" },
          { "text": "Pulley", "correct": false, "image": "" },
          { "text": "Wheel and axle", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. A pulley helps you…",
        "questionImage": "",
        "answers": [
          { "text": "Lift with a rope", "correct": true, "image": "" },
          { "text": "Cut wood", "correct": false, "image": "" },
          { "text": "Hold pieces together", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. A screw is used to…",
        "questionImage": "",
        "answers": [
          { "text": "Hold things together", "correct": true, "image": "" },
          { "text": "Roll across the floor", "correct": false, "image": "" },
          { "text": "Lift like a lever", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "simplemachines",
    "title": "Simple Machines",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each machine to what it does.",
        "options": [
          { "id": "lever", "text": "Lever", "image": "", "targetText": "Helps lift with a bar", "targetImage": "" },
          { "id": "pulley", "text": "Pulley", "image": "", "targetText": "Lifts with rope & wheel", "targetImage": "" },
          { "id": "wheelaxle", "text": "Wheel & axle", "image": "", "targetText": "Rolls to move loads", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match the name to the example.",
        "options": [
          { "id": "incline", "text": "Inclined plane", "image": "", "targetText": "Ramp", "targetImage": "" },
          { "id": "wedge", "text": "Wedge", "image": "", "targetText": "Doorstop/axe head", "targetImage": "" },
          { "id": "screw", "text": "Screw", "image": "", "targetText": "Jar lid/bolt", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each machine to its job.",
        "options": [
          { "id": "wedgeJob", "text": "Wedge", "image": "", "targetText": "Splits or cuts", "targetImage": "" },
          { "id": "inclineJob", "text": "Inclined plane", "image": "", "targetText": "Moves up with less force", "targetImage": "" },
          { "id": "wheelJob", "text": "Wheel & axle", "image": "", "targetText": "Reduces friction", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match parts to the machine.",
        "options": [
          { "id": "rope", "text": "Rope", "image": "", "targetText": "Pulley", "targetImage": "" },
          { "id": "fulcrum", "text": "Fulcrum", "image": "", "targetText": "Lever", "targetImage": "" },
          { "id": "threads", "text": "Threads", "image": "", "targetText": "Screw", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each machine to a simple picture idea.",
        "options": [
          { "id": "seesaw", "text": "Seesaw", "image": "", "targetText": "Lever", "targetImage": "" },
          { "id": "flagpole", "text": "Flagpole", "image": "", "targetText": "Pulley", "targetImage": "" },
          { "id": "roller", "text": "Roller", "image": "", "targetText": "Wheel & axle", "targetImage": "" }
        ]
      }
    ]
  },
  {
    "slug": "mixtures",
    "title": "Mixtures",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is a mixture?",
        "questionImage": "",
        "answers": [
          { "text": "Different things together", "correct": true, "image": "" },
          { "text": "One pure element", "correct": false, "image": "" },
          { "text": "Only a gas", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which can be separated easily by hand?",
        "questionImage": "",
        "answers": [
          { "text": "Trail mix", "correct": true, "image": "" },
          { "text": "Salt water", "correct": false, "image": "" },
          { "text": "Soda", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which mixture dissolves and stays combined?",
        "questionImage": "",
        "answers": [
          { "text": "Salt water", "correct": true, "image": "" },
          { "text": "Sand and rocks", "correct": false, "image": "" },
          { "text": "Buttons in a jar", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. A mixture that looks the same everywhere is…",
        "questionImage": "",
        "answers": [
          { "text": "A solution", "correct": true, "image": "" },
          { "text": "A sandwich", "correct": false, "image": "" },
          { "text": "A magnet", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which tool can help separate iron from sand?",
        "questionImage": "",
        "answers": [
          { "text": "A magnet", "correct": true, "image": "" },
          { "text": "A spoon", "correct": false, "image": "" },
          { "text": "A ruler", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "hotwaterdissolves",
    "title": "Hot Water Dissolves Faster",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Why does sugar dissolve faster in hot water?",
        "questionImage": "",
        "answers": [
          { "text": "Molecules move faster", "correct": true, "image": "" },
          { "text": "Water is colder", "correct": false, "image": "" },
          { "text": "Less sugar is used", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When water gains heat energy, its molecules…",
        "questionImage": "",
        "answers": [
          { "text": "Move faster", "correct": true, "image": "" },
          { "text": "Stop moving", "correct": false, "image": "" },
          { "text": "Freeze", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Stirring a cup usually makes dissolving…",
        "questionImage": "",
        "answers": [
          { "text": "Happen faster", "correct": true, "image": "" },
          { "text": "Stop completely", "correct": false, "image": "" },
          { "text": "Make ice", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Smaller sugar grains dissolve…",
        "questionImage": "",
        "answers": [
          { "text": "Faster than big ones", "correct": true, "image": "" },
          { "text": "Slower than big ones", "correct": false, "image": "" },
          { "text": "Not at all", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. A solid that dissolves is called a…",
        "questionImage": "",
        "answers": [
          { "text": "Solute", "correct": true, "image": "" },
          { "text": "Solvent", "correct": false, "image": "" },
          { "text": "Solution", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "adaptation",
    "title": "Adaptation",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is adaptation?",
        "questionImage": "",
        "answers": [
          { "text": "A way to survive", "correct": true, "image": "" },
          { "text": "A kind of food", "correct": false, "image": "" },
          { "text": "A machine part", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What helps animals blend in?",
        "questionImage": "",
        "answers": [
          { "text": "Camouflage", "correct": true, "image": "" },
          { "text": "Migration", "correct": false, "image": "" },
          { "text": "Recycling", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What helps animals look like something else?",
        "questionImage": "",
        "answers": [
          { "text": "Mimicry", "correct": true, "image": "" },
          { "text": "Hibernation", "correct": false, "image": "" },
          { "text": "Photosynthesis", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Moving to warmer places for winter is called…",
        "questionImage": "",
        "answers": [
          { "text": "Migration", "correct": true, "image": "" },
          { "text": "Camouflage", "correct": false, "image": "" },
          { "text": "Sprouting", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Sleeping through cold months is called…",
        "questionImage": "",
        "answers": [
          { "text": "Hibernation", "correct": true, "image": "" },
          { "text": "Pollination", "correct": false, "image": "" },
          { "text": "Germination", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "adaptivecharacteristics",
    "title": "Adaptive Characteristics",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Why do otters have webbed feet?",
        "questionImage": "",
        "answers": [
          { "text": "To swim better", "correct": true, "image": "" },
          { "text": "To climb trees", "correct": false, "image": "" },
          { "text": "To fly", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Sharp claws are used for…",
        "questionImage": "",
        "answers": [
          { "text": "Catching prey", "correct": true, "image": "" },
          { "text": "Making nests", "correct": false, "image": "" },
          { "text": "Eating grass", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Large beaks help animals with…",
        "questionImage": "",
        "answers": [
          { "text": "Eating", "correct": true, "image": "" },
          { "text": "Sleeping", "correct": false, "image": "" },
          { "text": "Running", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Large teeth help animals with…",
        "questionImage": "",
        "answers": [
          { "text": "Biting food", "correct": true, "image": "" },
          { "text": "Flying", "correct": false, "image": "" },
          { "text": "Hiding", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Adaptive traits help animals…",
        "questionImage": "",
        "answers": [
          { "text": "Survive", "correct": true, "image": "" },
          { "text": "Sing", "correct": false, "image": "" },
          { "text": "Dance", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "fossils",
    "title": "Fossils",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Fossils tell us about…",
        "questionImage": "",
        "answers": [
          { "text": "The past", "correct": true, "image": "" },
          { "text": "The future", "correct": false, "image": "" },
          { "text": "Today’s weather", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Fossils form mostly in…",
        "questionImage": "",
        "answers": [
          { "text": "Rock layers", "correct": true, "image": "" },
          { "text": "Clouds", "correct": false, "image": "" },
          { "text": "Fire", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Fossils can be from…",
        "questionImage": "",
        "answers": [
          { "text": "Plants or animals", "correct": true, "image": "" },
          { "text": "Plastic toys", "correct": false, "image": "" },
          { "text": "Metal cans", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What can uncover fossils over time?",
        "questionImage": "",
        "answers": [
          { "text": "Wind and rain", "correct": true, "image": "" },
          { "text": "TV waves", "correct": false, "image": "" },
          { "text": "Music", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Fossils are found…",
        "questionImage": "",
        "answers": [
          { "text": "Underground", "correct": true, "image": "" },
          { "text": "In the sky", "correct": false, "image": "" },
          { "text": "On the Moon", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "ecosystemlevels",
    "title": "Ecosystem Levels",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is the first level of an ecosystem?",
        "questionImage": "",
        "answers": [
          { "text": "Organism", "correct": true, "image": "" },
          { "text": "Population", "correct": false, "image": "" },
          { "text": "Community", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When organisms have young, they make a…",
        "questionImage": "",
        "answers": [
          { "text": "Population", "correct": true, "image": "" },
          { "text": "Ecosystem", "correct": false, "image": "" },
          { "text": "Mountain", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Different organisms together form a…",
        "questionImage": "",
        "answers": [
          { "text": "Community", "correct": true, "image": "" },
          { "text": "Rock", "correct": false, "image": "" },
          { "text": "Planet", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Living and nonliving things together form an…",
        "questionImage": "",
        "answers": [
          { "text": "Ecosystem", "correct": true, "image": "" },
          { "text": "Cloud", "correct": false, "image": "" },
          { "text": "River", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which level comes after organism?",
        "questionImage": "",
        "answers": [
          { "text": "Population", "correct": true, "image": "" },
          { "text": "Volcano", "correct": false, "image": "" },
          { "text": "Mountain", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "foodweb",
    "title": "Food Web",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each organism to who eats it.",
        "options": [
          { "id": "mice", "text": "Mice", "image": "", "targetText": "Snakes & owls", "targetImage": "" },
          { "id": "bugs", "text": "Bugs", "image": "", "targetText": "Birds & skunks", "targetImage": "" },
          { "id": "rabbits", "text": "Rabbits", "image": "", "targetText": "Foxes", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match producers to what they give.",
        "options": [
          { "id": "trees", "text": "Trees", "image": "", "targetText": "Acorns", "targetImage": "" },
          { "id": "plants", "text": "Plants", "image": "", "targetText": "Food for animals", "targetImage": "" },
          { "id": "grass", "text": "Grass", "image": "", "targetText": "Food for rabbits", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each eater to its food.",
        "options": [
          { "id": "owl", "text": "Owl", "image": "", "targetText": "Eats mice", "targetImage": "" },
          { "id": "snake", "text": "Snake", "image": "", "targetText": "Eats frogs/mice", "targetImage": "" },
          { "id": "bird", "text": "Bird", "image": "", "targetText": "Eats bugs", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Put web roles with their names.",
        "options": [
          { "id": "producer", "text": "Producer", "image": "", "targetText": "Makes food", "targetImage": "" },
          { "id": "consumer", "text": "Consumer", "image": "", "targetText": "Eats food", "targetImage": "" },
          { "id": "predator", "text": "Predator", "image": "", "targetText": "Hunts other animals", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each food chain step.",
        "options": [
          { "id": "acorn", "text": "Acorn", "image": "", "targetText": "Food for mice", "targetImage": "" },
          { "id": "mouse", "text": "Mouse", "image": "", "targetText": "Food for owl", "targetImage": "" },
          { "id": "owl2", "text": "Owl", "image": "", "targetText": "Top hunter", "targetImage": "" }
        ]
      }
    ]
  },
  {
    "slug": "foodchain",
    "title": "Food Chain",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What starts a food chain?",
        "questionImage": "",
        "answers": [
          { "text": "Producers", "correct": true, "image": "" },
          { "text": "Snakes", "correct": false, "image": "" },
          { "text": "Owls", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Grass is eaten by…",
        "questionImage": "",
        "answers": [
          { "text": "Grasshoppers", "correct": true, "image": "" },
          { "text": "Frogs", "correct": false, "image": "" },
          { "text": "Hawks", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What eats the grasshopper?",
        "questionImage": "",
        "answers": [
          { "text": "Frog", "correct": true, "image": "" },
          { "text": "Snake", "correct": false, "image": "" },
          { "text": "Hawk", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What eats the frog?",
        "questionImage": "",
        "answers": [
          { "text": "Snake", "correct": true, "image": "" },
          { "text": "Grass", "correct": false, "image": "" },
          { "text": "Producer", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What eats the snake?",
        "questionImage": "",
        "answers": [
          { "text": "Hawk", "correct": true, "image": "" },
          { "text": "Grasshopper", "correct": false, "image": "" },
          { "text": "Frog", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "soil",
    "title": "Soil",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Soil is a mixture of…",
        "questionImage": "",
        "answers": [
          { "text": "Organic matter, air, water", "correct": true, "image": "" },
          { "text": "Only rocks", "correct": false, "image": "" },
          { "text": "Only sand", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does soil give to plants?",
        "questionImage": "",
        "answers": [
          { "text": "Nutrients", "correct": true, "image": "" },
          { "text": "Music", "correct": false, "image": "" },
          { "text": "Wings", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What breaks down dead things in soil?",
        "questionImage": "",
        "answers": [
          { "text": "Microbes", "correct": true, "image": "" },
          { "text": "Clouds", "correct": false, "image": "" },
          { "text": "Stars", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Animals use soil for…",
        "questionImage": "",
        "answers": [
          { "text": "Homes", "correct": true, "image": "" },
          { "text": "Flying", "correct": false, "image": "" },
          { "text": "Swimming", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What causes rocks to break into soil?",
        "questionImage": "",
        "answers": [
          { "text": "Weathering", "correct": true, "image": "" },
          { "text": "Cooking", "correct": false, "image": "" },
          { "text": "Painting", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "soilsoilwhatcanyoudo",
    "title": "Soil Soil What Can You Do",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Sandy soil is…",
        "questionImage": "",
        "answers": [
          { "text": "Loose and light", "correct": true, "image": "" },
          { "text": "Heavy", "correct": false, "image": "" },
          { "text": "Sticky", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Sandy soil holds…",
        "questionImage": "",
        "answers": [
          { "text": "Little water", "correct": true, "image": "" },
          { "text": "Lots of air", "correct": false, "image": "" },
          { "text": "No sand", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Clay soil is…",
        "questionImage": "",
        "answers": [
          { "text": "Heavy and sticky", "correct": true, "image": "" },
          { "text": "Very loose", "correct": false, "image": "" },
          { "text": "Always dry", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. The best soil for plants is…",
        "questionImage": "",
        "answers": [
          { "text": "Loam", "correct": true, "image": "" },
          { "text": "Clay", "correct": false, "image": "" },
          { "text": "Sand", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Loam usually…",
        "questionImage": "",
        "answers": [
          { "text": "Holds and drains", "correct": true, "image": "" },
          { "text": "Blocks air", "correct": false, "image": "" },
          { "text": "Has no nutrients", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "whatdoplantsneed",
    "title": "What Do Plants Need",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Animals need…",
        "questionImage": "",
        "answers": [
          { "text": "Food and water", "correct": true, "image": "" },
          { "text": "Metal", "correct": false, "image": "" },
          { "text": "Plastic", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Animals also need…",
        "questionImage": "",
        "answers": [
          { "text": "Air and shelter", "correct": true, "image": "" },
          { "text": "Music", "correct": false, "image": "" },
          { "text": "Paint", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Aquatic means…",
        "questionImage": "",
        "answers": [
          { "text": "Lives in water", "correct": true, "image": "" },
          { "text": "Lives on land", "correct": false, "image": "" },
          { "text": "Lives in the sky", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Plants need…",
        "questionImage": "",
        "answers": [
          { "text": "Air and light", "correct": true, "image": "" },
          { "text": "Gold and salt", "correct": false, "image": "" },
          { "text": "Wheels", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Plants also need…",
        "questionImage": "",
        "answers": [
          { "text": "Water and nutrients", "correct": true, "image": "" },
          { "text": "Batteries", "correct": false, "image": "" },
          { "text": "Gasoline", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "formsofwater",
    "title": "Forms of Water",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each term to its meaning (set 1).",
        "options": [
          { "id": "reservoir1", "text": "Reservoir", "image": "", "targetText": "Stores water", "targetImage": "" },
          { "id": "groundwater1", "text": "Groundwater", "image": "", "targetText": "Beneath surface", "targetImage": "" },
          { "id": "river1", "text": "River", "image": "", "targetText": "Moving stream", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each term to its meaning (set 2).",
        "options": [
          { "id": "lake1", "text": "Lake", "image": "", "targetText": "Land-surrounded", "targetImage": "" },
          { "id": "bay1", "text": "Bay", "image": "", "targetText": "Partly enclosed", "targetImage": "" },
          { "id": "peninsula1", "text": "Peninsula", "image": "", "targetText": "3 sides water", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match place to location type.",
        "options": [
          { "id": "groundwater2", "text": "Groundwater", "image": "", "targetText": "Underground", "targetImage": "" },
          { "id": "lake2", "text": "Lake", "image": "", "targetText": "Inland water", "targetImage": "" },
          { "id": "bay2", "text": "Bay", "image": "", "targetText": "Coast", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match item to a key idea.",
        "options": [
          { "id": "reservoir2", "text": "Reservoir", "image": "", "targetText": "Collect/store", "targetImage": "" },
          { "id": "river2", "text": "River", "image": "", "targetText": "Flows/moves", "targetImage": "" },
          { "id": "peninsula2", "text": "Peninsula", "image": "", "targetText": "Mostly land", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each to category.",
        "options": [
          { "id": "lake3", "text": "Lake", "image": "", "targetText": "Water body", "targetImage": "" },
          { "id": "bay3", "text": "Bay", "image": "", "targetText": "Water body", "targetImage": "" },
          { "id": "peninsula3", "text": "Peninsula", "image": "", "targetText": "Landform", "targetImage": "" }
        ]
      }
    ]
  },
  {
    "slug": "watercycle",
    "title": "Water Cycle",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Evaporation needs…",
        "questionImage": "",
        "answers": [
          { "text": "Sun heat", "correct": true, "image": "" },
          { "text": "Moonlight", "correct": false, "image": "" },
          { "text": "Snow", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Condensation forms…",
        "questionImage": "",
        "answers": [
          { "text": "Clouds", "correct": true, "image": "" },
          { "text": "Rocks", "correct": false, "image": "" },
          { "text": "Sand", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Precipitation is…",
        "questionImage": "",
        "answers": [
          { "text": "Rain or snow", "correct": true, "image": "" },
          { "text": "Evaporation", "correct": false, "image": "" },
          { "text": "Melting", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. About how much of Earth is covered by water?",
        "questionImage": "",
        "answers": [
          { "text": "75%", "correct": true, "image": "" },
          { "text": "5%", "correct": false, "image": "" },
          { "text": "25%", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. The equator is…",
        "questionImage": "",
        "answers": [
          { "text": "An imaginary line", "correct": true, "image": "" },
          { "text": "A real river", "correct": false, "image": "" },
          { "text": "A mountain", "correct": false, "image": "" }
        ]
      }
    ]
  },
  
]

export default md3rdScienceQuizContent;
